/** Shared brand palette (aligned with admin sidebar + topbar). */
export const BRAND_COLORS = {
  sidebar: '#0f172a',
  sidebarMuted: '#1e293b',
  topbar: '#0C5A85',
  topbarDark: '#0a4563',
  accent: '#3b82f6',
  accentDark: '#2563eb',
  accentDeeper: '#1d4ed8',
} as const

export const BRAND_GRADIENTS = {
  adminHeader: `linear-gradient(135deg, ${BRAND_COLORS.sidebar} 0%, ${BRAND_COLORS.sidebarMuted} 100%)`,
  publicHeader: `linear-gradient(135deg, ${BRAND_COLORS.topbar} 0%, ${BRAND_COLORS.topbarDark} 100%)`,
  accent: `linear-gradient(135deg, ${BRAND_COLORS.accent} 0%, ${BRAND_COLORS.accentDark} 100%)`,
} as const

/** Defaults for page headers / section gradients when settings are empty. */
export const DEFAULT_HEADER_GRADIENT: { start: string; end: string } = {
  start: BRAND_COLORS.topbar,
  end: BRAND_COLORS.topbarDark,
}

/** Defaults for widget/section background gradients. */
export const DEFAULT_WIDGET_GRADIENT: { color1: string; color2: string } = {
  color1: BRAND_COLORS.topbar,
  color2: BRAND_COLORS.topbarDark,
}